exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".one-container[data-v-25d8d1c2]{background:#f2f2f2;border:1px dashed #0d6247}.one-konosament[data-v-25d8d1c2]{border-left:1px solid #ccc}.one-konosament[data-v-25d8d1c2]:hover{border-left:1px solid #0d6247}.delete-one-konosament[data-v-25d8d1c2]{position:absolute;width:80px;height:30px;top:40px;left:-60px;transform:rotate(-90deg)}.custom-select[data-v-25d8d1c2]{height:34px!important;border-radius:3px!important;padding:1px 8px}.small-description[data-v-25d8d1c2]{line-height:11px}", ""]);

// exports
